import base from './base.repository';
import base2 from './base2.repository';
export default {
    ...base,
    get: (payload) => base2.get('people', payload),
    byStructure(structureId){
        this.get(`people?structure=${structureId}`);
        return this;
    },
    search(term){
        this.get(`people?search=${term}`);
        return this;
    },
    searchPeopleOfClient(clientId, page, filters){
        const params = {...filters, page, client: clientId};
        return base2.get('people/search', params);
        // this.get(`people/search${this.querify(params)}`);
        // return this;
    },
    deletePerson(id, userId){
        this.delete('people/'+ id+'?user='+userId);
        return this;
    },
    updatePerson(person, id) {
        this.put('people/' + id, person);
        return this;
    },
    savePerson(person) {
        this.post(`people`, person);
        return this;
    },
    getPersonEntries(clientId, document){
        this.get(`person-entries?document=${document}&client=${clientId}`);
        return this;
    },
    async getPersonEntriesByClient(clientId, page, filters){
        // const theFilters = [
        //     `client=${clientId}`,
        //     `page=${page}`
        // ];
        // Object.keys(filters).map(key => {
        //     !!filters[key] && theFilters.push(`${key}=${filters[key]}`);
        // });

        // const queryParams = theFilters.join('&');
        // const queryString = !!queryParams?`?${queryParams}`:'';

        const params = {...filters, page, client: clientId};

        const {data} = await base2.get(`person-entries`, params);
        return data;
    },
    searchPersonByDocument(document, clientId){
        this.get(`people/search?document=${document}&client=${clientId}&internal=0`);
        return this;
    },
    getPendingPeople(clientId, page = 1){
        this.get(`people/client/${clientId}/pending-activation?page=${page}`);
        return this;
    },
    activateMobileUser(payload){
        this.post(`people/activate-user`, payload);
        return this;
    },
    getPeoplePendingActivation : (filters, page) => base2.get('people/pending-activation', {...filters, page}),
    updatePersonPhoto: (formData) => base2.post(`people/update-photo`, formData),
    getVenuePeopleByStructure: (clientId, structureId) => base2.get(`clients/${clientId}/people/${structureId}`),
}